<template>
  <div>
    <Modal v-model="isShowModal" width="1500px" height="100%">
      <baidu-map class="map" v-if="isShowModal" :center="map.center" :zoom="map.zoom" @ready="handler">
        <!--缩放-->
        <bm-navigation anchor="BMAP_ANCHOR_TOP_LEFT"></bm-navigation>
        <!--定位-->
        <bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true" :autoLocation="true"></bm-geolocation>
        <!--聚合动态添加的点坐标-->
        <bm-marker-clusterer :averageCenter="true">
          <bm-marker v-for="marker of markers" :key="marker.recoveryOrderId" @click="lookDetail(marker,'left')" :position="{lng: marker.longitude, lat: marker.latitude}"  :icon="{url: marker.icon, size: { width: 20, height: 20 }}"></bm-marker>
        </bm-marker-clusterer>
        <!--信息窗体-->
        <bm-info-window :position="{lng: infoWindow.info.longitude, lat: infoWindow.info.latitude}" :title="infoWindow.info.locationAddress + infoWindow.info.address" :show="infoWindow.show" @close="infoWindowClose" @open="infoWindowOpen">
          <p><span class="left">用户姓名：</span><span class="right">{{infoWindow.info.realName}}</span></p>
          <p><span class="left">用户电话：</span><span class="right">{{infoWindow.info.mobile}}</span></p>
          <p><span class="left">订单状态：</span><span class="right">{{getOrderState(infoWindow.info.orderState)}}</span></p>
          <p><span class="left">预约时间：</span><span class="right">{{infoWindow.info.recoveryTime}}</span></p>
          <p><span class="left">回收员：</span><span class="right">{{infoWindow.info.recoveryUserName}}</span></p>
        </bm-info-window>

        <view v-for="recovery in recoveryUserList">
          <bm-polygon :path="recovery.mapRange" stroke-color="blue" :stroke-opacity="0.5" :stroke-weight="2" :editing="false" @click="clicking(recovery.realName)"/>
        </view>
        <!--点-->
<!--        <bm-marker :position="map.center" :dragging="map.dragging" animation="BMAP_ANIMATION_DROP">-->
<!--          &lt;!&ndash;提示信息&ndash;&gt;-->
<!--          <bm-info-window :show="map.show">{{this.address}}</bm-info-window>-->
<!--        </bm-marker>-->
      </baidu-map>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "orderMap",
  data: () => ({
    admin: JSON.parse(sessionStorage.getItem('J-ADMIN')),
    isShowModal: false,
    show1: false,
    address: '',
    map:{
      center: {
        lng: '116.6163470719684',
        lat: '35.45582592983'
      },
      zoom: 15,
      show: true,
      dragging: true
    },
    markers:[],
    longitude: '',
    latitude: '',
    infoWindow: {
      lng: 0,
      lat: 0,
      show: false,
      info:{
      },
    },
    recoveryUserList: [],
  }),
  methods: {
    clicking(name) {
      this.$Message.success('回收人员：' + name);
    },
    getOrderState(orderState) {
      console.log('orderState', orderState)
      if (orderState === 1) {
        return '未接单'
      } else if (orderState === 2) {
        return '已接单'
      } else if (orderState === 5) {
        return '申请取消'
      }
    },
    // 显示模态框
    show() {
      this.getTenantById()
      this.findList();
      this.findRecoveryUserList();
      setTimeout(() => {
        this.isShowModal = true;
      }, 1000)
    },
    handler ({BMap, map}) {
      console.log('执行handler')
      let me = this;
      // console.log(BMap, map)
      // 鼠标缩放
      map.enableScrollWheelZoom(true);
      // map.panBy(580, 150);
    },
    getTenantById() {
      let params = {
        tenantId: this.admin ? this.admin.tenantId : ''
      }
      this.axios.post('/tenant/getTenantInfo', params).then(res => {
        if (res.status == 200) {
          console.log('res', res)
          this.map.center = {lng: res.data.longitude, lat: res.data.latitude}
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '查询代理商接口报错',
            duration: 0
          });
        }
      })
    },
    showItem(item) {
      console.log('点击')
      this.show1 = true
    },
    infoWindowClose() {
      this.show1 = false
    },
    infoWindowOpen() {
      this.show1 = true
    },
    lookDetail(data, target) {
      this.infoWindow.show =true;
      this.infoWindow.info=data;
    },
    findList() {
      let params = {
        type: 2
      }
      this.axios.post('/recoveryOrder/findMapList', params).then(res => {
        this.isTableLoading = false;
        if (res.status == 200) {

          this.longitude = res.data[0].longitude
          this.latitude = res.data[0].latitude
          this.address = res.data[0].address
          if (res.data) {
            res.data.forEach(item => {
              if (item.orderState === 1) {
                item.icon = require('@/assets/poi_green.png');
              } else if (item.orderState === 2 && item.isAbnormal != 1) {
                item.icon = require('@/assets/poi_red.png');
              } else if (item.orderState === 5 && item.isAbnormal != 1) {
                item.icon = require('@/assets/poi_yellow.png');
              } else if (item.isAbnormal == 1) {
                item.icon = require('@/assets/poi_purple.png');
              }
            })
          }
          this.markers = res.data
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '查询订单列表接口报错',
            duration: 0
          });
        }
      })
    },
    findRecoveryUserList() {
      let params = {
        page: 1,
        rows: 99,
      }
      this.axios.post('/recoveryUser/findList', params).then(res => {
        if (res.status == 200) {
          let rows = res.data.rows
          if (rows) {
            let recoveryUser = []
            rows.forEach(item => {
              if (item.mapRange) {
                let mapRangeStr = item.mapRange.substring(2);
                mapRangeStr = mapRangeStr.substring(0, mapRangeStr.length - 2);
                let mapRange = []
                let mapRangeArr = mapRangeStr.split(';');
                mapRangeArr.forEach(v => {
                  let local = v.split(',');
                  let item = {
                    lng: local[0],
                    lat: local[1]
                  }
                  mapRange.push(item);
                });
                item.mapRange = mapRange
                recoveryUser.push(item);
              }
            });
            this.recoveryUserList = recoveryUser
          }
        }
        if (res.status == 500) {
          this.$Notice.error({
            title: '服务器内部错误',
            desc: '查询回收员列表接口报错',
            duration: 0
          });
        }
      })
    },
  }
}
</script>

<style scoped>
.map {
  width: 100%;
  height: 840px;
}
</style>
